<script>
    import { createEventDispatcher } from 'svelte';

    export let isPhoneIcon,
        isWifiIcon,
        isTvIcon,
        isSmartphoneIcon,
        selected,
        value,
        data_package,
        title;

    const dispatch = createEventDispatcher();

    const handleChange = () => {
        dispatch('updateSelected', value);
    };

    const icons = {
        phone: '/assets/img/icons/symbol-defs.svg#icon-phone-thin',
        movil: '/assets/img/icons/symbol-defs.svg#icon-smartphone',
        wifi: '/assets/img/icons/symbol-defs.svg#icon-wifi',
        tv: '/assets/img/icons/symbol-defs.svg#icon-tv',
    };
</script>

<div class="single-package">
    <input
        type="radio"
        name="package_type"
        id="package_izzi_{value}"
        data-package={data_package}
        checked={selected === value}
        {value}
        on:change={handleChange}
    />
    <label for="package_izzi_{value}">
        <span class="package-check__indicator"
            ><img
                src="/assets/img/icons/check.svg"
                alt=""
                aria-hidden="true"
            /></span
        >
        <div class="package-icons">
            {#if isPhoneIcon}
                <svg class="icon"><use xlink:href={icons.phone} /></svg>
            {/if}
            {#if isWifiIcon}
                <svg class="icon"><use xlink:href={icons.wifi} /></svg>
            {/if}
            {#if isTvIcon}
                <svg class="icon"><use xlink:href={icons.tv} /></svg>
            {/if}
            {#if isSmartphoneIcon}
                <svg class="icon"><use xlink:href={icons.movil} /></svg>
            {/if}
        </div>
        <p>{@html title}</p>
    </label>
</div>
